import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/storeUtils';
import { apiWrapper } from '../../api/apiWrapper';

export const thunks = {
  getDancersList: createThunk('dancers/getDancersList', () =>
    apiWrapper.get(WEB_API_ROUTES.dancers.list)
  ),

  sendEmail: createThunk(
    'dancers/sendEmail',
    ({ subject, messageText, messageFor }) =>
      api.post(WEB_API_ROUTES.dancers.email, {
        messageFor,
        subject,
        messageText,
      }),
    'Message sent'
  ),

  sendSms: createThunk(
    'dancers/sendSms',
    ({ messageText, messageFor }) =>
      api.post(WEB_API_ROUTES.dancers.sms, {
        messageFor,
        messageText,
      }),
    'Message sent'
  ),
};

export const importDancers = createThunk(
  'dancers/importDancers',
  (file) => {
    const formData = new FormData();
    formData.append('file', file);

    return api.post(WEB_API_ROUTES.dancers.importCsv, formData, {
      params: { app: 'studio' },
    });
  },
  (data) => data.message
);

thunks.importDancers = importDancers;
